import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-059eb000"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat_title" }
const _hoisted_2 = { class: "chat-container" }
const _hoisted_3 = { class: "date_wrap" }
const _hoisted_4 = { class: "date-badge" }
const _hoisted_5 = { class: "footer_container space-between" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request" }, " 다른 조건으로 제안 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request" }, " 이 조건에 팔기 ", -1))
const _hoisted_8 = { class: "footer_container space-between" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request" }, " 협의 취소 ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request" }, " 조건 수정 ", -1))
const _hoisted_11 = { class: "footer_container space-between" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request" }, " 나가기 ", -1))
const _hoisted_13 = { class: "footer_container space-between" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "request" }, " 협의 취소 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_sell_message = _resolveComponent("sell-message")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    class: "ion-activatable ripple-parent",
                    "default-href": "/tabs/channel-list",
                    icon: _ctx.chevronBack,
                    onClick: _cache[0] || (_cache[0] = () => _ctx.router.push('/tabs/channel-list'))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ]),
                    _: 1
                  }, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.LeadNickname), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        id: "ionContent",
        fullscreen: true,
        "scroll-events": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageMap.keys(), (key, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: "days-chat"
              }, [
                _withDirectives(_createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.printDate(key)), 1)
                ], 512), [
                  [_vShow, idx !== 0]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageMap.get(key), (m) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: m,
                    class: "message-content"
                  }, [
                    _createVNode(_component_sell_message, {
                      "child-message": m,
                      "user-id": _ctx.userId
                    }, null, 8, ["child-message", "user-id"])
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, {
        class: "ion-no-border",
        "no-padding": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent khaki_btn footer_btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.suggestToLeadAngel('suggestToLeadAngel')))
                  }, [
                    _hoisted_6,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ]),
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent green_btn footer_btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createModal('approveToLeadAngel')))
                  }, [
                    _hoisted_7,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.channelStatus === 'suggestToSeller' || _ctx.channelStatus === 'reSuggestToSeller']
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent khaki_btn footer_btn",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelToLeadAngel && _ctx.cancelToLeadAngel(...args)))
                  }, [
                    _hoisted_9,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ]),
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent green_btn footer_btn",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.suggestToLeadAngel('reSuggestToLeadAngel')))
                  }, [
                    _hoisted_10,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.channelStatus === 'suggestToLeadAngel' || _ctx.channelStatus === 'reSuggestToLeadAngel']
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent khaki_btn footer_btn",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.router.go(-1)))
                  }, [
                    _hoisted_12,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.channelStatus === 'cancelToSeller' || _ctx.channelStatus === 'cancelToLeadAngel' || _ctx.channelStatus === 'complete']
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent khaki_btn footer_btn",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.cancelToLeadAngel && _ctx.cancelToLeadAngel(...args)))
                  }, [
                    _hoisted_14,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.channelStatus === 'approveToSeller' || _ctx.channelStatus === 'approveToLeadAngel']
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}